import { render, staticRenderFns } from "./ScheduleRecordList.vue?vue&type=template&id=bf23a074&scoped=true"
import script from "./ScheduleRecordList.vue?vue&type=script&lang=js"
export * from "./ScheduleRecordList.vue?vue&type=script&lang=js"
import style0 from "./ScheduleRecordList.vue?vue&type=style&index=0&id=bf23a074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf23a074",
  null
  
)

export default component.exports